export enum ActivityDictionary {
    Interviewing = 'Interviewing',
    TrailingDoc = 'Trailing Doc',
    NewLoan = 'New Loan',
}
